import { useLayoutEffect, useRef, useState } from 'react'

import { EMPTY_OBJECT } from '../constants/common'

import { useAnimationFrame } from './useAnimationFrame'

export function useIsScrollable({ externalRef } = EMPTY_OBJECT) {
  const [isHorizontalScrollable, setHorizontalScrollable] = useState(false)
  const [isVerticalScrollable, setVerticalScrollable] = useState(false)

  const internalRef = useRef(null)

  const ref = externalRef ?? internalRef

  function handleMeasure() {
    if (ref.current) {
      setVerticalScrollable(ref.current.scrollHeight > ref.current.offsetHeight)
      setHorizontalScrollable(ref.current.scrollWidth > ref.current.offsetWidth)
    }
  }

  // Deferred a frame: the scrollable state resizes the observed element itself,
  // which is the `ResizeObserver loop completed with undelivered notifications` error
  const [scheduleMeasure] = useAnimationFrame(handleMeasure)

  useLayoutEffect(() => {
    if (ref.current) {
      const observer = new ResizeObserver(scheduleMeasure)

      observer.observe(ref.current)

      return function cleanup() {
        observer.disconnect()
      }
    }
  }, [scheduleMeasure])

  return { isHorizontalScrollable, isVerticalScrollable, ref }
}
